export default "__VITE_ASSET__vM9Qezdh__"